/* Listón · un listón rojo de regalo que cose las secciones y acaba en un moño junto al botón de compra final.
   El trazo es el de la landing de HourlyUGC (scroll-ribbon.tsx, SWEEP_D en una caja de 1440 × 160), pero calculado
   en píxeles reales del ancho de cada pantalla: el nudo queda redondo también a 390 px (con preserveAspectRatio="none"
   se aplasta). Cada tramo se dibuja una sola vez cuando se ve más de la mitad. No escucha el scroll.
   Sin JS no hay listón (es decoración); con ?quieto=1 o «menos movimiento» aparece ya dibujado. */
(() => {
  const qs = new URLSearchParams(location.search);
  const quieto = qs.has("quieto") || matchMedia("(prefers-reduced-motion: reduce)").matches;
  const NS = "http://www.w3.org/2000/svg";

  // SWEEP_D de scroll-ribbon.tsx: [x0,y0] y luego curvas [c1x,c1y,c2x,c2y,x,y]
  const BARRIDO = [[0, 66], [150, 38, 280, 40, 356, 76], [412, 103, 430, 132, 404, 144], [378, 156, 356, 130, 376, 106],
    [402, 74, 486, 64, 600, 76], [840, 100, 1060, 112, 1230, 102], [1320, 96, 1390, 86, 1440, 74]];

  /* El nudo (x 330-500 de la caja) se escala igual en x que en y; lo de antes y lo de después se estira al ancho */
  function mapa(W, H) {
    const s = H / 160, L = Math.max(40, 0.23 * W - 85 * (1 - s)), z = 170 * s;
    const fx = (x) => (x <= 330 ? (x * L) / 330 : x <= 500 ? L + (x - 330) * s : L + z + ((x - 500) * (W - L - z)) / 940);
    const fy = (y) => y * s;
    return { fx, fy, s };
  }
  const n = (v) => Math.round(v * 10) / 10;

  function barrido(W, H, lado, tramos = BARRIDO.length) {
    const { fx, fy } = mapa(W, H);
    const X = (x) => (lado === "der" ? W - fx(x) : fx(x));
    const p = BARRIDO.slice(0, tramos);
    let d = `M${n(X(p[0][0]) + (lado === "der" ? 6 : -6))} ${n(fy(p[0][1]))}`;
    for (const c of p.slice(1)) d += `C${n(X(c[0]))} ${n(fy(c[1]))} ${n(X(c[2]))} ${n(fy(c[3]))} ${n(X(c[4]))} ${n(fy(c[5]))}`;
    if (tramos === BARRIDO.length) d += `L${lado === "der" ? -6 : W + 6} ${n(fy(74))}`;
    return d;
  }

  /* El moño: dos lazadas y dos colas alrededor del nudo K, de radio r. La primera cola sigue el trazo; la segunda va aparte */
  function mono(kx, ky, r) {
    const a = (dx, dy) => `${n(kx + dx * r)} ${n(ky + dy * r)}`;
    const lazos = `C${a(-0.25, -0.95)} ${a(-1.05, -1.05)} ${a(-1.02, -0.38)}C${a(-1, 0.22)} ${a(-0.36, 0.12)} ${a(0, 0)}` +
      `C${a(0.25, -0.95)} ${a(1.05, -1.05)} ${a(1.02, -0.38)}C${a(1, 0.22)} ${a(0.36, 0.12)} ${a(0, 0)}` +
      `C${a(-0.12, 0.42)} ${a(-0.42, 0.74)} ${a(-0.62, 1.12)}`;
    const cola = `M${a(0, 0)}C${a(0.12, 0.42)} ${a(0.38, 0.78)} ${a(0.52, 1.16)}`;
    return { lazos, cola };
  }

  const largo = (p) => { try { return Math.ceil(p.getTotalLength()) + 2; } catch { return 4000; } };
  function trazo(svg, d, clase, retardo, dur) {
    for (const tipo of ["cinta", "brillo"]) {
      let p = svg.querySelector(`.${clase}.lazo__${tipo}`);
      if (!p) { p = document.createElementNS(NS, "path"); p.setAttribute("class", `${clase} lazo__${tipo}`); svg.appendChild(p); }
      p.setAttribute("d", d);
      p.style.setProperty("--largo", largo(p));
      p.style.setProperty("--d", `${retardo}ms`);
      p.style.setProperty("--dur", `${dur}ms`);
    }
  }
  function lienzo(el) {
    let svg = el.querySelector("svg.lazo__svg");
    if (!svg) { svg = document.createElementNS(NS, "svg"); svg.setAttribute("class", "lazo__svg"); svg.setAttribute("aria-hidden", "true"); svg.setAttribute("focusable", "false"); el.prepend(svg); }
    return svg;
  }

  function alVerse(el, objetivo) {
    if (quieto || !("IntersectionObserver" in window)) return;
    el.dataset.estado = "espera";
    const io = new IntersectionObserver((entradas) => entradas.forEach((e) => {
      const mitad = e.intersectionRatio >= 0.5 || e.intersectionRect.height >= innerHeight * 0.5;
      if (e.isIntersecting && mitad) { el.dataset.estado = "anima"; io.disconnect(); }
    }), { threshold: [0, 0.25, 0.5, 0.75, 1], rootMargin: "0px 0px -10% 0px" });
    io.observe(objetivo || el);
  }

  /* ── Costuras: una franja entre dos secciones ── */
  document.querySelectorAll("[data-lazo-costura]").forEach((el) => {
    const svg = lienzo(el);
    const pintar = () => {
      const W = el.clientWidth, H = el.clientHeight;
      if (!W || !H) return;
      svg.setAttribute("viewBox", `0 0 ${W} ${H}`);
      trazo(svg, barrido(W, H, el.dataset.lazoCostura === "der" ? "der" : "izq"), "lazo__tramo", 0, 640);
    };
    pintar();
    if ("ResizeObserver" in window) new ResizeObserver(pintar).observe(el);
    alVerse(el);
  });

  /* ── El final: del borde de la sección baja hasta el botón y se ata en moño a su lado ── */
  document.querySelectorAll("[data-lazo-final]").forEach((sec) => {
    const boton = sec.querySelector("[data-lazo-boton]");
    if (!boton) return;
    const placa = boton.closest("[data-lazo-placa]") || boton.parentElement;
    const svg = lienzo(sec);
    let nudo = svg.querySelector(".lazo__nudo");
    if (!nudo) { nudo = document.createElementNS(NS, "rect"); nudo.setAttribute("class", "lazo__nudo"); }

    // Rectángulos de texto de la sección (para no pasar nunca por encima de uno)
    const textos = (base) => {
      const out = [], w = document.createTreeWalker(sec, NodeFilter.SHOW_TEXT, { acceptNode: (t) => (t.data.trim() ? 1 : 3) });
      const r = document.createRange();
      for (let t; (t = w.nextNode());) { r.selectNodeContents(t); for (const q of r.getClientRects()) out.push({ x0: q.left - base.left, x1: q.right - base.left, y0: q.top - base.top, y1: q.bottom - base.top }); }
      return out;
    };
    const choca = (a, lista, m = 4) => lista.some((b) => a.x0 < b.x1 + m && a.x1 > b.x0 - m && a.y0 < b.y1 + m && a.y1 > b.y0 - m);

    const pintar = () => {
      const W = sec.clientWidth;
      const H = W < 900 ? 112 : 160; // la franja del nudo, centrada en el borde de arriba de la sección
      const b = sec.getBoundingClientRect();
      const base = { left: b.left, top: b.top - H / 2 };
      const rb = boton.getBoundingClientRect(), rp = placa.getBoundingClientRect();
      const bt = { x0: rb.left - base.left, x1: rb.right - base.left, y0: rb.top - base.top, y1: rb.bottom - base.top };
      const pl = { x1: rp.right - base.left };
      const kyB = (bt.y0 + bt.y1) / 2, borde = H / 2, txt = textos(base);
      const fotos = [...sec.querySelectorAll("img")].map((i) => { const q = i.getBoundingClientRect(); return { x0: q.left - base.left, x1: q.right - base.left, y0: q.top - base.top, y1: q.bottom - base.top }; });
      const R0 = W < 900 ? 22 : 26;
      const xg = Math.min(W - 7, pl.x1 + Math.max(8, (W - pl.x1) / 2)); // centro del margen derecho

      /* Dónde se ata, por orden: 1) a la derecha del botón, dentro de la placa; 2) colgado bajo la flecha del botón;
         3) sobre el borde de la placa; 4) en el margen. Se queda el primero que no toca ni un texto ni el botón. */
      const bajo = [26, 24, 22, 20, 18].map((r) => ({ kx: bt.x1 - 27, ky: bt.y1 + r * 1.05 + 8, r, xv: xg, ok: bt.x1 - 27 + r <= pl.x1 - 6, lado: "bajo" }));
      const candidatos = [
        { kx: bt.x1 + 14 + R0, ky: kyB, r: R0, ok: bt.x1 + 14 + 2 * R0 + 8 <= pl.x1, lado: "placa" },
        ...bajo,
        (() => { const kx = pl.x1 - 2, r = Math.min(R0, kx - bt.x1 - 4, W - kx - 3); return { kx, ky: kyB, r, xv: xg, ok: r >= 14, lado: "borde" }; })(),
        (() => { const kx = (pl.x1 + W) / 2, r = Math.min(R0, (W - pl.x1) / 2 - 3); return { kx, ky: kyB, r, ok: r >= 14, lado: "margen" }; })(),
      ];
      // La entrada al moño desde el margen (la misma curva que se dibuja), muestreada para comprobarla
      const entrada = (c) => {
        const P = [[c.xv, c.ky - c.r * 1.9], [c.xv, c.ky - c.r * 0.9], [c.kx + c.r * 0.4, c.ky - c.r * 0.55], [c.kx, c.ky]];
        return Array.from({ length: 13 }, (_, i) => { const t = i / 12, u = 1 - t;
          const x = u * u * u * P[0][0] + 3 * u * u * t * P[1][0] + 3 * u * t * t * P[2][0] + t * t * t * P[3][0];
          const y = u * u * u * P[0][1] + 3 * u * u * t * P[1][1] + 3 * u * t * t * P[2][1] + t * t * t * P[3][1];
          return { x0: x - 2, x1: x + 2, y0: y - 2, y1: y + 2 }; });
      };
      const libre = (c) => c.ok &&
        !choca({ x0: (c.xv ?? c.kx) - 3, x1: (c.xv ?? c.kx) + 3, y0: borde, y1: c.ky - c.r * (c.xv ? 1.9 : 1) }, [...txt, ...fotos]) &&
        // el moño respira: 10 px de aire con cualquier texto y 4 con el botón
        !choca({ x0: c.kx - c.r * 1.06, x1: c.kx + c.r * 1.06, y0: c.ky - c.r * 1.06, y1: c.ky + c.r * 1.2 }, txt, 10) &&
        !choca({ x0: c.kx - c.r * 1.06, x1: c.kx + c.r * 1.06, y0: c.ky - c.r * 1.06, y1: c.ky + c.r * 1.2 }, [bt, ...fotos], 4) &&
        !(c.xv && c.xv !== c.kx && entrada(c).slice(2, -2).some((q) => choca(q, [...txt, bt, ...fotos], 2)));
      const elegido = candidatos.find(libre) || candidatos.find((c) => c.lado === "borde");
      const { kx, ky, r } = elegido, xv = elegido.xv ?? kx;

      // Barrido con el nudo (los 5 primeros tramos de SWEEP_D), giro hacia abajo y bajada recta hasta el moño
      const Htot = Math.ceil(b.height + H / 2);
      const { fx, fy } = mapa(W, H);
      const yT = fy(76) + 4, R = Math.min(48, Math.max(24, (xv - fx(600)) / 3));
      let d = barrido(W, H, "izq", 5);
      d += `C${n(fx(600) + (xv - R - fx(600)) * 0.45)} ${n(yT)} ${n(xv - R - 30)} ${n(yT)} ${n(xv - R)} ${n(yT)}`;
      d += `Q${n(xv)} ${n(yT)} ${n(xv)} ${n(yT + R)}`;
      d += xv === kx ? `L${n(kx)} ${n(ky)}` : `L${n(xv)} ${n(ky - r * 1.9)}C${n(xv)} ${n(ky - r * 0.9)} ${n(kx + r * 0.4)} ${n(ky - r * 0.55)} ${n(kx)} ${n(ky)}`;
      const m = mono(kx, ky, r);
      svg.setAttribute("viewBox", `0 0 ${W} ${Htot}`);
      sec.style.setProperty("--lazo-franja", `${H}px`);
      sec.style.setProperty("--lazo-alto", `${Htot}px`);
      trazo(svg, d + m.lazos, "lazo__tramo", 0, 760);
      trazo(svg, m.cola, "lazo__cola", 600, 220);
      const k = r * 0.17;
      Object.entries({ x: n(kx - k * 1.2), y: n(ky - k * 1.3), width: n(k * 2.4), height: n(k * 2.6), rx: n(k * 0.9) }).forEach(([a, v]) => nudo.setAttribute(a, v));
      svg.appendChild(nudo);
      sec.dataset.lazoLado = elegido.lado;
    };
    pintar();
    if ("ResizeObserver" in window) new ResizeObserver(pintar).observe(sec);
    if (document.fonts) document.fonts.ready.then(pintar);
    alVerse(sec, placa);
  });
})();
